/**
 * @description Always returns an object with parameters - name: value.
 */
export const getUrlParams = () => {
  const { search } = window.location;

  if (search.length === 0) return {};

  const hashes = search
    .replace(/%5B/g, '[')
    .replace(/%5D/g, ']')
    .replace(/\+/g, ' ')
    .slice(search.indexOf('?') + 1)
    .split('&');

  return hashes.reduce((params, hash) => {
    const [key, val] = hash.split('=');
    return { ...params, [key]: decodeURIComponent(val) };
  }, {});
};

/**
 * @description Sets a parameter to the URL according to the specified arguments.
 * @param {String} name
 * @param {String|Number} value
 */
export const setUrlParam = (name, value) => {
  const url = window.location.href;

  if (!name) return url;
  if (value === undefined || value === '') return url;

  const pattern = new RegExp(`\\b(${name}=).*?(&|#|$)`);

  if (url.search(pattern) >= 0) {
    return url.replace(pattern, `$1${value}$2`);
  }

  return `${url}${url.indexOf('?') > 0 ? '&' : '?'}${name}=${value}`;
};

export default {
  getUrlParams,
  setUrlParam,
};
